import qs from 'qs';
import { Api } from '../../../core/api';

const api = new Api({
  initialData: [],
  useEagleApi: true,
  namespace: 'ARTICLES_LIST',
  url: '/internal-intranet/articles',
});

const listApi = new Api({
  initialData: [],
  useEagleApi: true,
  namespace: 'ARTICLES_LIST',
  url: '/internal-intranet/search/articles',
});

const deleteArticlesApi = new Api({
  namespace: 'ARTICLES_DELETE',
  useEagleApi: true,
  options: {
    method: 'DELETE',
  },
  throwable: true,
  url: `/internal-intranet/articles`,
});

interface IFetchParams {
  search?: string;
  hash?: string;
}

export const fetchArticles = ({ hash, search }: IFetchParams = {}) => {
  let searchPhrase = '';
  if (hash) {
    const searchString = hash.split('#')[1];

    searchPhrase = search
      ? `&search=${searchString}`
      : `?search=${searchString}`;
  }
  const params = qs.parse(search?.slice(1) as string);
  const searchParams = qs.parse(searchPhrase?.slice(1) as string);
  const body = JSON.stringify({
    page: +params.page || 0,
    pageSize: +params.limit || 10,
    sort: { order: [{ direction: 'DESC', property: 'createdAt' }] },
    filter: searchParams.search
      ? {
          filters: [
            {
              property: 'title',
              type: 'containsIgnoreCase',
              value: searchParams.search,
            },
          ],
        }
      : null,
  });
  return listApi.fetch({
    options: {
      method: 'POST',
      body,
    },
  });
};

export const removeArticle = (id: string) =>
  deleteArticlesApi.fetch({
    options: {
      body: JSON.stringify({
        ids: [id],
      }),
    },
  });

export const reducer = api.reducer;
